export default __webpack_public_path__ + "static/media/nareppo.80a8e5c0.png";